// @ts-nocheck - TODO: Add jQuery type declarations and fix dialog prop types
/* eslint-disable no-unused-vars, no-undef */
import ky from 'ky';
import { Col, Row } from 'react-bootstrap';
import { BsEmojiSunglasses as EmojiSunglasses } from 'react-icons/bs';

const controller = new AbortController();
const { signal } = controller;

import { BayDialogConfirm } from '../../BayDialog';

import NotificationItem from './NotificationItem';

interface Notification {
	id: string;
	type: string;
	notificationid: string;
	title?: string;
	publicid?: string;
	instancedate?: number;
}

interface NotificationType {
	[key: string]: string;
}

interface NotificationHeaderProps {
	name: string;
	count: number;
	item: string;
	snoozeAllFunc: (item: string, name: string) => void;
}

interface NotificationFeedProps {
	setArrayCount: (arr: Notification[]) => void;
	feedArray: Notification[];
	openModalFunc: (type: string, id: string | Notification[], title: string, notificationid?: string | string[]) => void;
	onCloseFunc: () => void;
}

const NotificationHeader = ({ name, count, item, snoozeAllFunc }: NotificationHeaderProps) => {
	return (
		<div className="bay-notifications-header">
			{name}
			<div>
				<span className="badge me-2">{count}</span>
				<button
					className="btn btn-xs btn-snooze"
					type="button"
					onClick={() => snoozeAllFunc(item, name)}
				>
					Snooze All
				</button>
			</div>
		</div>
	);
};

const NotificationFeed = ({
	setArrayCount,
	feedArray,
	openModalFunc,
	onCloseFunc,
}: NotificationFeedProps) => {
	// Our notification types
	const notificationTypes: NotificationType[] = [
		{ leads: 'Leads' },
		{ teamleads: 'Team Leads' },
		{ textmessages: 'Text Messages' },
		{ message: 'Messages' },
		{ todos: 'To Do' },
		{ calendar: 'Calendar' },
		{ calendareventapproval: 'Event Approvals' },
	];

	const snoozeItem = (id: string, title: string, notificationid: string) => {
		openModalFunc('snooze', id, title, notificationid);
	};

	const snoozeAll = (item: string, title: string) => {
		openModalFunc(
			'snooze',
			item,
			title,
			feedArray.filter((e) => e.type === item).map((e) => e.id),
		);
	};

	// NOTE: Make sure to await the confirm or the callback function
	// fires immediately upon the confirm opening.
	const showCancelConfirm = async (callBackFunc: () => void) => {
		if (
			await BayDialogConfirm({
				confirmation:
					'Are you sure you want to deny this lead? The record for this lead will be removed.',
				options: {
					title: 'Deny lead?',
					buttonText: 'Confirm',
					variant: 'danger',
				},
			})
		) {
			//console.log('yes')
			callBackFunc();
		} else {
			//console.log('no')
		}
	};

	/**
	 *
	 * @param {int} notificationid
	 * @param {boolean} isLead
	 * @param {boolean} accept
	 * @param  {...any} rest
	 */
	const handleNotificationClick = async (
		notificationid: string,
		isLead = false,
		accept = false,
		publicid?: string,
		instanceDate = 0,
	) => {
		if (isLead && accept) {
			await handleLeadAction(notificationid, publicid, true);
		} else if (isLead && !accept) {
			await showCancelConfirm(handleLeadAction(notificationid, publicid));
		} else {
			/* eslint-disable-next-line no-undef */
			$.iqCalendar_EventPopup(notificationid, instanceDate);
		}

		window.globalStore.dispatch(window.globalStore.fetchNotifications());
	};

	const handleLeadAction = async (ContactID: string, PublicID?: string, acceptLead?: boolean) => {
		try {
			const formData = new FormData();
			formData.append('method', acceptLead ? 'DoAccept' : 'DoDecline');
			formData.append('returnformat', 'json');
			formData.append('contactID', ContactID);
			formData.append('publicID', PublicID || '');

			const res = await ky
				.post('/global/components/contactmanagement.cfc', {
					body: formData,
					signal,
					retry: 2,
					timeout: 30000,
				})
				.json<{ STATUS: number; MESSAGE?: string; DETAIL?: string; CONTENT?: string }>();

			if (res.STATUS === 0) {
				if (acceptLead) {
					/* eslint-disable-next-line no-undef */
					$.iqContactManagement_MaintainContact(
						'update',
						ContactID,
						PublicID,
						'Details',
						1,
					);
				}
				window.globalStore.dispatch({
					type: 'notifications/removeNotification',
					payload: ContactID,
				});
				const newArray = feedArray.filter((e) => e.notificationid !== ContactID);
				setArrayCount(newArray);
			} else {
				/* 				$.iqUIMessage(
					'',
					jsonRet.MESSAGE + '<br>' + jsonRet.DETAIL + '<br>' + jsonRet.CONTENT,
				); */
				if (
					await BayDialogConfirm({
						confirmation: `Unable to process notification. Please review following error message:
							${res.MESSAGE}
							<br/>
							${res.DETAIL}
							<br/>
							${res.CONTENT}
							`,
						options: {
							title: 'Unable to process notification',
							hideCancelButton: true,
						},
					})
				) {
					//console.log('yes')
				}
			}
		} catch (error) {
			if (error.name === 'AbortError') {
				console.log('Lead action aborted by user');
			} else {
				console.error('Lead action error:', error);
			}
		}
	};

	return (
		<div className="feed-wrapper" style={{ padding: '0px 0.5rem' }}>
			{feedArray?.length > 0 ? (
				notificationTypes.map((obj, index) => {
					const item = Object.keys(obj)[0];
					return feedArray.filter((e) => e.type === item).length > 0 ? (
						<div key={index} className="item-notification">
							<div className="bay-notifications">
								<NotificationHeader
									count={feedArray.filter((e) => e.type === item).length}
									item={item}
									name={obj[item]}
									snoozeAllFunc={snoozeAll}
								/>
								{feedArray
									.filter((e) => e.type === item)
									.map((notification, index) => {
										return (
											<div key={index}>
												<NotificationItem
													handleNotificationClick={handleNotificationClick}
													notification={notification}
													snoozeFunc={snoozeItem}
													onCloseFunc={onCloseFunc}
												/>
											</div>
										);
									})}
							</div>
						</div>
					) : null;
				})
			) : (
				<div className="p-2 align-content-center justify-content-center">
					<Row>
						<Col>
							<span className="h3 text-muted">Congrats!</span>
							<p className="text-dark">
								Looks like you're all caught up. <EmojiSunglasses size={20} />
							</p>
						</Col>
					</Row>
				</div>
			)}
		</div>
	);
};

export default NotificationFeed;
